import * as React from 'react';
import {useEffect, useRef} from 'react';
import Modal from '../../presentations/Modal';
import {useSelector} from 'react-redux';
import store, {AppState} from '../../stores';
import {open as openHistoryModal} from '../../stores/history-modal';
import {close} from '../../stores/missed-call-modal';
import MissedCall from './MissedCall';
import ModalBody from '../../presentations/ModalBody';
import Padding from '../../presentations/Padding';
import Button from '../../presentations/Button';
import ModalHeaderSimple from '../../presentations/ModalHeaderSimple';
import ModalFooterSimple from '../../presentations/ModalFooterSimple';

const MissedCallModal: React.FC = () => {
  const ref: any = useRef();
  const open     = useSelector((state: AppState) => state.missedCallModal.open);

  useEffect(() => {
    if (open) {
      ref.current.open();
    } else {
      ref.current.close();
    }
  }, [open]);

  const handleClose = () => {
    store.dispatch(close());
  }

  const handleViewMissedCalls = () => {
    store.dispatch(close());
    store.dispatch(openHistoryModal('MISSED'));
  }

  return (
          <Modal ref={ref} onClose={handleClose}>
            <>
              <ModalHeaderSimple>不在着信</ModalHeaderSimple>
              <ModalBody>
                <Padding padding={'0 20px 20px'}>
                  <MissedCall/>
                </Padding>
              </ModalBody>
              <ModalFooterSimple>
                  <Button type={'button'} color={'secondary'} onClick={handleClose}>閉じる</Button>
                  <Button type={'button'} color={'primary'} margin={'0 0 0 10px'} onClick={handleViewMissedCalls}>不在着信を見る</Button>
              </ModalFooterSimple>
            </>
          </Modal>
  );
}

export default MissedCallModal;

